import styled from 'styled-components'

export const Container = styled.div`
    position: absolute;
    top: 0;
    width: 95%;
    max-height: 25rem;
    min-height: 5rem;
    background: #FFF;
    box-shadow: 0 2px 4px rgb(0 0 0 / 10%), 0 8px 16px rgb(0 0 0 / 10%);
    transform: translateY(-103%);
    padding: 1rem;
    border-radius: 7px;
    overflow-x: auto;

    -webkit-font-smoothing: antialiased;   
    user-select: none;

    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;
`
